(function () {
  const WISHLIST_KEY = 'onhow-wishlist';

  function getWishlistItems() {
    try {
      const data = localStorage.getItem(WISHLIST_KEY);
      const items = data ? JSON.parse(data) : [];
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function updateHeartState() {
    const svg = document.querySelector('.wishlist-button svg');
    const btn = document.querySelector('.wishlist-button');
    if (!svg || !btn) return;

    const count = getWishlistItems().length;

    if (count > 0) {
      svg.style.setProperty('fill', '#BB133E', 'important');
      svg.style.setProperty('stroke', '#BB133E', 'important');
    } else {
      svg.style.removeProperty('fill');
      svg.style.removeProperty('stroke');
    }

    // Update counter badge
    let counter = btn.querySelector('.wishlist-counter');
    if (!counter) {
      counter = document.createElement('span');
      counter.className = 'wishlist-counter';
      btn.appendChild(counter);
    }
    counter.textContent = count > 0 ? count : '';
    counter.setAttribute('data-count', count);
  }

  function updateProductButtonIcon() {
    const productBtn = document.querySelector('button:has(.onhow-wishlist-text)');
    if (!productBtn) return;

    const count = getWishlistItems().length;
    const filledSVG = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23BB133E' stroke='%23BB133E' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E")`;
    const outlineSVG = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E")`;

    // Inject a dynamic style tag to override ::before
    let styleTag = document.getElementById('wishlist-btn-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'wishlist-btn-style';
      document.head.appendChild(styleTag);
    }

    styleTag.textContent = count > 0
      ? `button:has(.onhow-wishlist-text)::before { background-image: ${filledSVG} !important; }`
      : `button:has(.onhow-wishlist-text)::before { background-image: ${outlineSVG} !important; }`;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateHeartState();
      updateProductButtonIcon();
    });
  } else {
    updateHeartState();
    updateProductButtonIcon();
  }

  window.addEventListener('storage', function () {
    updateHeartState();
    updateProductButtonIcon();
  });

  setInterval(function () {
    updateHeartState();
    updateProductButtonIcon();
  }, 1000);

  document.addEventListener('click', function (e) {
    if (e.target.closest('button:has(.onhow-wishlist-text)') || e.target.closest('.wishlist-button')) {
      setTimeout(function () {
        updateHeartState();
        updateProductButtonIcon();
      }, 500);
      setTimeout(function () {
        updateHeartState();
        updateProductButtonIcon();
      }, 1000);
    }
  });
})();
